import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ConfirmeValidators } from "src/app/shared/directives/validators/confirme-validators";
import { ModalGenericoModel } from "src/app/shared/models/modal.model";
import { AlertsService } from "src/app/shared/services/alerts.service";
import { DepositarioProvisionalService } from "../../containers/bandeja-principal/administrador/gestion/depositario-provisional/depositario-provisional.service";

@Component({
  selector: "app-modal-asignar-depositario",
  templateUrl: "./modal-asignar-depositario.component.html",
  styleUrls: ["./modal-asignar-depositario.component.scss"],
})
export class ModalAsignarDepositarioComponent implements OnInit {
  @Input()
  modalGenerico: ModalGenericoModel;
  formAsignarDepositario: FormGroup;
  usuariosLista: Array<any> = null;
  asignar: boolean;
  keyword = "infoCadena";

  constructor(
    public depositarioProvisionalService: DepositarioProvisionalService,
    public formBuilder: FormBuilder,
    public alertService: AlertsService,
    private activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    if (this.asignar) {
      this.depositarioProvisionalService
        .getUsuariosDepositarios()
        .subscribe((resultado) => {
          for (let index = 0; index < resultado.data.length; index++) {
            resultado.data[index] = {
              ...resultado.data[index],
              infoCadena:
                resultado.data[index].nombres +
                " " +
                resultado.data[index].apellidos +
                " - " +
                resultado.data[index].numero_identificacion,
            };
          }
          this.usuariosLista = resultado.data as Array<any>;
        });
      this.formAsignarDepositario = this.formBuilder.group({
        usuario_id: [null, Validators.required],
        observaciones: [
          null,
          [Validators.required, ConfirmeValidators.noWhitespace],
        ],
      });
    } else {
      this.formAsignarDepositario = this.formBuilder.group({
        observaciones: [
          null,
          [Validators.required, ConfirmeValidators.noWhitespace],
        ],
      });
    }
  }

  selectEvent(item: any) {
    this.formAsignarDepositario.controls["usuario_id"].setValue(
      item.usuario_id
    );
  }

  clearAutocomplete(e) {
    this.formAsignarDepositario.controls["usuario_id"].setValue(null);
  }

  dismiss(): void {
    if (this.activeModal) {
      this.activeModal.dismiss();
    }
  }

  sendForm(): void {
    if (this.activeModal) {
      if (this.formAsignarDepositario.value.observaciones.length > 4000) {
        this.alertService.warn(
          "Solo se permite hasta 4000 carácteres en la observación",
          "",
          "sin-codigo"
        );
      } else {
        this.activeModal.close(this.formAsignarDepositario.value);
      }
    }
  }
}
